import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IUnorderedArrivalResult } from '../domains/entities/IUnorderedArrivalResult';
import { initPagingOptions, IPagingOptions } from '@/coreDomainsModule/paging';
import { OrderAdapter } from '../adapters/OrderAdapter';
import { IOrderStatusFilterItem } from '@/coreDomainsModule/entities/order';
import { FilterContentItem, FreeColumnFilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IOrderRepository } from '@/coreInfrastructureModule/interfaces/IOrderRepository';

/**
 *  「発注情報」を取ってきてUI表示ように加工するUseCase
 */
export class GetUnorderedArrivalUseCase {
  private defaultPagingOptions: IPagingOptions = initPagingOptions(30);
  private repository: IOrderRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IOrderRepository) {
    this.repository = repository;
  }

  /**
   *  TableDataをBusinessManagerから抽出する
   * @param isUnexportedOnly - 未出力のみ取得するか
   * @param pagingOptions - ページングオプション
   * @param sortKey - ソートキー
   * @param isAsc - 昇順かどうか
   * @param filterItems - フィルター項目
   * @param orderStatusFilterItem - 発注ステータスのフィルター
   * @param freeColumnFilterItems - 自由カラムのフィルター項目
   */
  public Execute = async (
    isUnexportedOnly: boolean,
    pagingOptions?: IPagingOptions,
    sortKey?: string,
    isAsc?: boolean,
    filterItems?: FilterContentItem[],
    orderStatusFilterItem?: IOrderStatusFilterItem,
    freeColumnFilterItems: FreeColumnFilterContentItem[] = []
  ): Promise<INetworkResult<IUnorderedArrivalResult, Error>> => {
    try {
      const usePagingOptions = pagingOptions || this.defaultPagingOptions;
      const useFilterItem = filterItems ? FilterService.convertCustomerForecastFilterItems(filterItems) : undefined;
      const useOrderStatusFilterItem = FilterService.convertOrderStatusFilter(orderStatusFilterItem);
      const { aggregateFreeColumns } = FilterService.convertFreeColumnFilterItems(freeColumnFilterItems);
      const result = await this.repository.get(
        isAsc ? 'ASC' : 'DESC',
        usePagingOptions.pageSize,
        usePagingOptions.offset,
        isUnexportedOnly,
        sortKey,
        useFilterItem,
        useOrderStatusFilterItem,
        undefined,
        undefined,
        aggregateFreeColumns
      );

      switch (result.status.type) {
        case 'success':
          break;
        case 'error':
          throw result.status.error;
        default:
          throw Error('想定外のエラー');
      }

      const unorderedArrivalResult = OrderAdapter.adapt(result.status.data);

      return {
        status: {
          type: 'success',
          data: unorderedArrivalResult,
        },
      };
    } catch (error) {
      console.error('error', error); // 基本的にはここには来ない
      return {
        status: {
          type: 'error',
          error: Error('想定外のエラー'),
        },
      };
    }
  };
}
